<template>
  <label :for="name" v-if="label">{{ label }}</label>
  <component v-for="option in options" :key="option" :is="vertical ? 'div' : 'span'">
    <BaseRadio
      class="mt-2 ml-2 hover:bg-blue-100 cursor-pointer"
      v-bind="$attrs"
      :title="option.name"
      :label="option.name"
      :value="option.value"
      :name="name"
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
    />
  </component>
</template>
<script lang="ts">
// use normal <scrip> to declare options
/// https://vuejs.org/guide/components/attrs.html#disabling-attribute-inheritance
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { NameValue } from "../sharedTypes";

withDefaults(
  defineProps<{
    label?: string;
    modelValue?: string | number;
    options?: NameValue[];
    name?: string;
    vertical?: boolean;
  }>(),
  {
    label: "",
    vertical: false,
  }
);
</script>
